var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._g(
      { staticClass: "header-control-item", class: [_vm.iconTransitionClass] },
      _vm.$listeners
    ),
    [
      _c(
        "i",
        {
          staticClass: "header-control-item-icon",
          attrs: { "data-count": _vm.dataCount }
        },
        [_vm._t("icon")],
        2
      ),
      _vm._v(" "),
      _c("span", { staticClass: "header-control-item-text" }, [
        _vm._v(_vm._s(_vm.title))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }